type ValidationFunction = (value: string) => string | null;

interface ValidationRules {
  [key: string]: ValidationFunction;
}

const validations: ValidationRules = {
  customerPhone: (value) => /^\+?[0-9 ]+$/.test(value.replace(/^ +| +$/g, "")) && /[0-9]/.test(value) && !/[\r\n]/.test(value)
    ? null : 'Số điện thoại chỉ được chứa chữ số, khoảng trắng và dấu + ở đầu.',
  customerTaxId: (value) => /^(?:[0-9]{10}|[0-9]{13}|[0-9]{10}-[0-9]{3})$/.test(value.trim())
    ? null : 'Mã số thuế phải có 10 hoặc 13 chữ số, hoặc dạng 10 chữ số-3 chữ số.',
  customerNumber: (value) => /^[0-9]+$/.test(value.trim()) && Number(value) <= 2147483647
    ? null : 'Giá trị phải là số nguyên không âm, tối đa 2147483647.',

  number: (value: string) => {
    return isNaN(Number(value)) ? 'Giá trị phải là số' : null;
  },
  phone: (value: string) => {
    const phoneRegex = /^(\+84|0)[3|5|7|8|9][0-9]{8}$/;
    return phoneRegex.test(value) ? null : 'Số điện thoại không hợp lệ';
  },
  email: (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) ? null : 'Email không hợp lệ';
  },
};

export const validate = (value: string, rules: string): string | null => {
  if (rules.includes('customerPhone') ? value.replace(/ /g, '') === '' : value.trim() === '') return null;

  const ruleList = rules.split(',').map(rule => rule.trim());
  for (const rule of ruleList) {
    const validationFunction = validations[rule];
    if (validationFunction) {
      const error = validationFunction(value);
      if (error) return error;
    }
  }
  return null;
};
